import { FC } from 'react'

import { useTitle } from 'hooks/useTitle'
import { DemandElasticityDashboard } from 'modules/demandElasticity/components'

const DemandElasticityPage: FC = () => {
  useTitle('menu.demandElasticity')

  return <DemandElasticityDashboard />
}

export default DemandElasticityPage
